import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'ndms-confirm-remove',
  templateUrl: './confirm-remove.component.html',
  styleUrls: ['./confirm-remove.component.css']
})
export class ConfirmRemoveComponent implements OnInit {

  @Output() complete = new EventEmitter();
  objectToRemove: string = "";
  
  constructor() { }

  ngOnInit() {
    console.log("msg: ", this.objectToRemove);
  }
  yes() {
    this.complete.emit("yes");
  }
  cancel() {
    this.complete.emit("no");
  }
}
